import { ReactElement, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import ConfirmSignup from './ConfirmSignup';
import Signup from './Signup';
import './SignupContainer.scss';

/* eslint-disable-next-line */
interface Props {
  submitDisable: boolean;
}

export default function SignupContainer({ submitDisable }: Props): ReactElement {
  const [step, setStep] = useState<number>(1);
  useEffect(() => {
    const step = localStorage.getItem('step');
    if (Number(step)) {
      setStep(Number(step));
    } else {
      setStep(1);
    }
    return () => {
      setStep(1);
    };
  }, []);

  return (
    <section style={{ overflow: 'auto' }}>
      <div className="flex-b">
        <span className="text-gray text-left font-size m-0">Register</span>
        <NavLink
          to="/"
          onClick={() => {
            localStorage.removeItem('step');
            localStorage.removeItem('pin_time');
            localStorage.removeItem('email');
          }}
          className="text-left link text-blue"
        >
          Login
        </NavLink>
      </div>
      <div className="mt-10">
        <p className="step-text">{`STEP ${step}/2`}</p>
        <p className="step-text profile-info-text">{step === 1 ? 'Profile Information' : 'Email Verification'} </p>
      </div>
      {step === 1 ? (
        <Signup submitDisable={submitDisable} setStep={(step) => setStep(step)} />
      ) : (
        <ConfirmSignup setStep={(step) => setStep(step)} />
      )}
    </section>
  );
}
